var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backHomeWrap"},[_c('a',{staticClass:"backHome",attrs:{"href":"javascript:;"},on:{"click":_vm.goHome}},[_c('i',{staticClass:"iconfont iconhome"}),_vm._v(" "+_vm._s(_vm.shopName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }